// @flow

import React from "react";
import dayjs from "dayjs";

import { ProductStatus } from "./../../../helpers/enums";
import { convertStatusToDisplayName, toNICEDateString } from "./../../../helpers/utils";

type PropsType = {
	product: TopicListProductType,
	index: number
};

export const Product = (props: PropsType) => {

	const statusesToDisplay = props.product.status.filter(s => s !== ProductStatus.Published);

	return <li>
    	<article className="card">
			<header className="card__header">
				<h3 className="card__heading">
					<a href={props.product.href} className="gtm-topic-list-product" data-result-index={props.index + 1}>
						<data value={props.product.id}>
							{props.product.title}{props.product.showIdInTitle && ` (${props.product.id})`}
						</data>
					</a>
				</h3>
			</header>
			<dl className="card__metadata">
				{statusesToDisplay.length > 0 ? (
					<div className="card__metadatum">
						<dt className="visually-hidden">Status:</dt>
						<dd>
							{statusesToDisplay.map(status => convertStatusToDisplayName(status)).join(" | ")}
						</dd>
					</div>
				) : (
					<div className="card__metadatum">
						<dt className="visually-hidden">Product type:</dt>
						<dd>
							{props.product.productType.singular}
						</dd>
					</div>
				)}
				{props.product.programmeName &&
					<div className="card__metadatum">
						<dt className="visually-hidden">Programme:</dt>
						<dd>
							{props.product.programmeName}
						</dd>
					</div>
				}
				{(props.product.displayDates || []).map(date => (
					<div className="card__metadatum" key={date.label}>
						<dt>{date.label}:&nbsp;</dt>
						<dd>
							{date.date ? (
								<time dateTime={dayjs(date.date).format("YYYY-MM-DD")}>{toNICEDateString(date.date)}</time>
							) : (
								date.fallbackString
							)}
						</dd>
					</div>
				))}
			</dl>
		</article>
	</li>;
};

export default Product;
